import dev.fritz2.lenses.Lens
import dev.fritz2.lenses.buildLens

val hotelLens: Lens<Map<String, Boolean>, Boolean> = buildLens("hotel", { it["hotel"] ?: false }, { p, v -> p + ("hotel" to v)})
val busLens: Lens<Map<String, Boolean>, Boolean> = buildLens("bus", { it["bus"] ?: false }, { p, v -> p + ("bus" to v)})

fun mapLens(key: String): Lens<Map<String, Boolean>, Boolean> = buildLens(key, { it[key] ?: false }, { p, v -> p + (key to v) })